import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";

import { getAge } from "../NewStudentForm";

// Custom
import "../../general.css";
import "./DetailsApprovePhase.css";

import { submitNewStudentToGroup } from "../../../backend/firebaseFunctions";
import { useState } from "react";

export default function DetailsApprovePhase(props) {
  const {
    formState,
    setFormState,
    userField,
    newStudentData,
    newParentsData,
    setProgress,
    ID,
    groupID,
    studentPhoto,
    setCurrentStep,
    paymentCheck,
    groupData,
    formConfig,
  } = props;

  // Determine the correct back step based on centralized config
  const getBackStep = () => {
    if (formConfig.hasPaymentUrl && formConfig.hasPaymentCheck) {
      return 6; // Go back to payment check step
    } else if (!formConfig.hasPaymentUrl && formConfig.hasPaymentCheck) {
      return 5; // Go back to payment check step
    } else if (formConfig.hasPaymentUrl && !formConfig.hasPaymentCheck) {
      return 5; // Go back to payment link step
    } else {
      return 4; // Go back to parents details step
    }
  };

  const studentAge = getAge(
    new Date(
      newStudentData.birthYear,
      newStudentData.birthMonth - 1,
      newStudentData.birthDay
    )
  );

  const [userAgreesTerms1, setUserAgreesTerms1] = useState(false);
  const [userAgreesTerms2, setUserAgreesTerms2] = useState(false);
  const [userAgreesTerms3, setUserAgreesTerms3] = useState(false);

  const agreements = [
    {
      id: 1,
      text: "אני מודע/ת לכך כי הפרטים המזהים שהזנתי כעת והתמונה שצירפתי בתהליך הרישום ישמשו למאגר מידע פנימי של ארגון המאמן, על ידי השלמת ביצוע ההרשמה אני נותן/ת ומביע/ה את הסכמתי לכך.",
      checked: userAgreesTerms1,
      setChecked: setUserAgreesTerms1,
    },
    {
      id: 2,
      text: "ידוע לי, שבמהלך הפעילות השנתית המאמן/ת מצלם/ת את פעילויות הקבוצה ומשתף את קהילת ההורים ברשתות החברתיות בסרטונים ובתמונות בהם מופיעים הספורטאים. במידה ולא אהיה מעוניין/ת בכך, איידע את המאמן/ת.",
      checked: userAgreesTerms2,
      setChecked: setUserAgreesTerms2,
    },
    {
      id: 3,
      text: "אני מאשר למאמן / מועדון לבצע את ההרשמה של בני / בתי בפורטל ההתאחדות / במנהל הספורט של הענף.",
      checked: userAgreesTerms3,
      setChecked: setUserAgreesTerms3,
    },
  ];

  return (
    <div className="contentContainer">
      {formState === "normal" ? (
        <>
          <h1 className="newtext newbiggerText">אישור הפרטים</h1>
          <div className="approveContainer">
            <img
              src={studentPhoto}
              className="imagePreviewAAprove"
              alt="תמונת חניך"
            />
            <h2 className="newtext newmediumText">פרטי החניך</h2>
            <div className="studentDetails">
              <div className="detailsRow">
                <p className="newtext newsmallerText">{`${newStudentData.personalName} ${newStudentData.familyName}`}</p>
                <p className="newtext newsmallerText">שם מלא</p>
              </div>
              <div className="detailsRow">
                <p className="newtext newsmallerText">
                  {new Date(
                    Number(newStudentData.birthYear),
                    Number(newStudentData.birthMonth - 1),
                    Number(newStudentData.birthDay)
                  ).toLocaleDateString()}
                </p>
                <p className="newtext newsmallerText">תאריך לידה</p>
              </div>
              <div className="detailsRow">
                <p className="newtext newsmallerText">
                  {newStudentData.isBoy ? `זכר` : `נקבה`}
                </p>
                <p className="newtext newsmallerText">מין</p>
              </div>
              <div className="detailsRow">
                <p className="newtext newsmallerText">
                  {newStudentData.IDnumber}
                </p>
                <p className="newtext newsmallerText">תעודת זהות</p>
              </div>
              <div className="detailsRow">
                <p className="newtext newsmallerText">
                  {newStudentData.address}
                </p>
                <p className="newtext newsmallerText">כתובת מגורים</p>
              </div>
              {userField === "martial_arts" && (
                <>
                  <div className="detailsRow">
                    <p className="newtext newsmallerText">
                      {newStudentData.specialFields.beltLevel}
                    </p>
                    <p className="newtext newsmallerText">חגורה</p>
                  </div>
                  <div className="detailsRow">
                    <p className="newtext newsmallerText">{`${newStudentData.specialFields.weightKG} ק"ג`}</p>
                    <p className="newtext newsmallerText">משקל</p>
                  </div>
                </>
              )}
              {userField === "ball_games" && (
                <>
                  <div className="detailsRow">
                    <p className="newtext newsmallerText">
                      {newStudentData.specialFields.shirtSize}
                    </p>
                    <p className="newtext newsmallerText">מידת חולצה</p>
                  </div>
                  <div className="detailsRow">
                    <p className="newtext newsmallerText">
                      {newStudentData.specialFields.pantsSize}
                    </p>
                    <p className="newtext newsmallerText">מידת מכנסיים</p>
                  </div>
                </>
              )}
            </div>

            <h2 className="newtext newmediumText">
              {studentAge >= 19
                ? "פרטי קשר"
                : newParentsData.parentOneMail &&
                  newParentsData.parentOnePhone &&
                  newParentsData.parentOneName &&
                  newParentsData.parentTwoMail &&
                  newParentsData.parentTwoPhone &&
                  newParentsData.parentTwoName
                  ? "פרטי הורים"
                  : "פרטי הורה"}
            </h2>
            <div className="parentsDetails">
              {newParentsData.parentOneMail &&
                newParentsData.parentOnePhone &&
                newParentsData.parentOneName && (
                  <>
                    {studentAge < 19 && (
                      <div className="detailsRow">
                        <p className="newtext newsmallerText">
                          {newParentsData.parentOneName}
                        </p>
                        <p className="newtext newsmallerText">שם</p>
                      </div>
                    )}
                    <div className="detailsRow">
                      <p className="newtext newsmallerText">
                        {newParentsData.parentOnePhone}
                      </p>
                      <p className="newtext newsmallerText">טלפון</p>
                    </div>
                    <div className="detailsRow">
                      <p className="newtext newsmallerText">
                        {newParentsData.parentOneMail}
                      </p>
                      <p className="newtext newsmallerText">דוא"ל</p>
                    </div>
                  </>
                )}
              {newParentsData.parentTwoMail &&
                newParentsData.parentTwoPhone &&
                newParentsData.parentTwoName && (
                  <>
                    <div className="detailsRow">
                      <p className="newtext newsmallerText">שם</p>
                      <p className="newtext newsmallerText">
                        {newParentsData.parentTwoName}
                      </p>
                    </div>
                    <div className="detailsRow">
                      <p className="newtext newsmallerText">טלפון</p>
                      <p className="newtext newsmallerText">
                        {newParentsData.parentTwoPhone}
                      </p>
                    </div>
                    <div className="detailsRow">
                      <p className="newtext newsmallerText">דוא"ל</p>
                      <p className="newtext newsmallerText">
                        {newParentsData.parentTwoMail}
                      </p>
                    </div>
                  </>
                )}
            </div>
          </div>

          <div className="agreements-section">
            {agreements.map((agreement) => (
              <div key={agreement.id} className="agreement-item">
                <Form.Check
                  type="checkbox"
                  className="agreement-checkbox"
                  checked={agreement.checked}
                  onChange={(e) => agreement.setChecked(e.target.checked)}
                />
                <p className="newtext newsmallerText">{agreement.text}</p>
              </div>
            ))}
          </div>

          {(!userAgreesTerms1 || !userAgreesTerms2 || !userAgreesTerms3) && (
            <div className="terms-warning">
              אנא אשר/י את כל התנאים כדי להמשיך
            </div>
          )}

          <div className="form-actions">
            <Button
              variant="secondary"
              className="newtext newsmallerText"
              onClick={() => setCurrentStep(getBackStep())}
            >
              חזור
            </Button>
            <Button
              variant="primary"
              className="newtext newsmallerText"
              disabled={
                !userAgreesTerms1 || !userAgreesTerms2 || !userAgreesTerms3
              }
              onClick={async () => {
                setFormState("sending");
                const finalStudentData = {
                  age: studentAge || 0,
                  birthday: new Date(
                    newStudentData.birthYear || new Date().getFullYear(),
                    (newStudentData.birthMonth || 1) - 1,
                    newStudentData.birthDay || 1
                  ),
                  firstParentName: newParentsData.parentOneName || "",
                  firstParentNumber: newParentsData.parentOnePhone || "",
                  firstParentEmailAddress: newParentsData.parentOneMail || "",
                  secondParentName: newParentsData.parentTwoName || "",
                  secondParentNumber: newParentsData.parentTwoPhone || "",
                  secondParentEmailAddress: newParentsData.parentTwoMail || "",
                  gender: newStudentData.isBoy ? "זכר" : "נקבה",
                  name: `${newStudentData.personalName || ""} ${newStudentData.familyName || ""
                    }`,
                  IDnumber: newStudentData.IDnumber || "",
                  address: newStudentData.address || "",
                  specialFields: newStudentData.specialFields || {},
                  paymentCheckData: newStudentData?.paymentCheckData || {
                    creditCardDigits: "",
                    InvoiceString: "",
                  },
                };

                if (userField === "martial_arts") {
                  finalStudentData.beltColor =
                    newStudentData.specialFields?.beltLevel;
                }

                const sent = await submitNewStudentToGroup(
                  ID,
                  groupID,
                  finalStudentData,
                  studentPhoto
                );

                if (sent) {
                  setCurrentStep(7);
                } else {
                  setFormState("failed");
                }
              }}
            >
              הפרטים נכונים, הירשם לקבוצה
            </Button>
          </div>
        </>
      ) : formState === "sending" ? (
        <div className="spinnerContainer">
          <div className="custom-spinner"></div>
          <div className="spinner-message">
            מבצע רישום לקבוצה
            <span className="loading-dots"></span>
          </div>
        </div>
      ) : formState === "failed" ? (
        <div className="spinnerContainer">
          <p
            className="newtext"
            style={{
              color: "#dc3545",
              fontSize: "1.1rem",
              marginBottom: "1rem",
            }}
          >
            אירעה שגיאה בתהליך הרישום
          </p>
          <Button
            variant="primary"
            className="newtext newsmallerText"
            onClick={() => setFormState("normal")}
          >
            נסה שנית
          </Button>
        </div>
      ) : null}
    </div>
  );
}
